import { Usuario } from "../usuario"
import { Titulo } from "./Titulo"

export interface BaixaDePagamento {
	id: string
	titulo: Titulo
	transactionId: string
	valorPagamento: number
	dataHoraPagamento: string
	isTaxa: boolean
	isIntegracao: boolean
	usuarioRecebimento: string
	tipoDeTransacao: TipoDeTransacaoDaBaixaDePagamento | null
	estornado: boolean | null
	valorJurosSobreBaixa: number
	valorDaMultaSobreBaixa: number
	valorDeDescontoNosJuros: number
	valorDeDescontoNaMulta: number
	tipoDeDesconto: string
	valorAcrescimo?: number
	baixaDePagamentoOrigemId?: string
	detalhesDoPagamentoId?: string
}

export interface BaixaDePagamentoAuditada {
	id: string
	formaDePagamento: string | null
	titulo: Titulo
	transactionId: string
	valorPagamento: number
	dataHoraPagamento: string
	isTaxa: boolean
	isIntegracao: boolean
	fechamentoDeCaixaAuditado: boolean
	editandoFormaDePagamento: boolean
	editandoDataDoPagamento: boolean
	turnoDeVendaId: string | null | undefined
	created_at: string
	usuarioRecebimento: Usuario
	tipoDeTransacao: TipoDeTransacaoDaBaixaDePagamento | null
	estornado: boolean | null
	valorDesconto: number
	valorJurosSobreBaixa: number
	valorDaMultaSobreBaixa: number
	valorDeDescontoNosJuros: number
	valorDeDescontoNaMulta: number
	tipoDeDesconto: string
	valorAcrescimo?: number
	baixaDePagamentoOrigemId?: string
	detalhesDoPagamentoId?: string
}

export interface BaixaDePagamentoForm {
	titulo: Titulo | null
	transactionId: string
	valorPagamento: number
	valorTaxa: number
	dataHoraPagamento: string
	isTaxa: boolean
	isIntegracao: boolean
	formaDePagamento: string | null
	valorDesconto: number
	turnoDeVendaId: string | null | undefined
	tipoDeTransacao: TipoDeTransacaoDaBaixaDePagamento | null
	estornado: boolean | null
	valorJurosSobreBaixa: number
	valorDaMultaSobreBaixa: number
	valorTotalTitulo: number
	valorDeDescontoNosJuros: number
	valorDeDescontoNaMulta: number
	tipoDeDesconto: string
	valorAcrescimo?: number
	baixaDePagamentoOrigemId?: string
	detalhesDoPagamentoId?: string
}


export interface BaixaDePagamentoMultiploForm {
	titulo: Titulo[] | null
	transactionId: string
	valorPagamento: number
	valorTaxa: number
	dataHoraPagamento: string
	isTaxa: boolean 
	isIntegracao: boolean
	formaDePagamento: string | null
	turnoDeVendaId: string | null | undefined
	valorJurosSobreBaixa: number
	valorDaMultaSobreBaixa: number
	tipoDeTransacao: TipoDeTransacaoDaBaixaDePagamento | null
	valorDeDescontoNosJuros: number
	valorDeDescontoNaMulta: number
	tipoDeDesconto: string
}

export enum TipoDeTransacaoDaBaixaDePagamento {
	BAIXA = "Baixa",
	ESTORNO = "Estorno"
}